import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-criminal-event-grid',
  templateUrl: './new-criminal-event-grid.component.html',
  styleUrls: ['./new-criminal-event-grid.component.css']
})
export class NewCriminalEventGridComponent implements OnInit {
  title="Add Criminal Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/criminal-events/new-criminal-event-grid/new-criminal-event-grid.component.ts